export const MODULE = {
  pivotConsole: 'PIVOT-CONSOLE',
};
